export default "__VITE_ASSET__5fab8768__"